"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../../../components/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var Slider = function Slider(_ref) {
  var min = _ref.min,
      max = _ref.max,
      value = _ref.value,
      step = _ref.step,
      onChange = _ref.onChange,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["min", "max", "value", "step", "onChange"]);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    className: classes.Input,
    type: "range",
    min: min,
    max: max,
    value: value,
    step: step,
    onChange: onChange,
    "data-test-id": "input-slider"
  }, rest));
};

exports["default"] = Slider;
//# sourceMappingURL=index.js.map